import 'react';
import { CodeCore } from '../shared/components/Code.mjs';
import styled from '../../../../../node_modules/@mui/material/styles/styled.mjs';

const Code = styled(CodeCore)(({ theme })=>({
        ...theme.typography.body2,
        color: theme.styleConfig.colors.accentText,
        backgroundColor: theme.styleConfig.colors.accent
    }));

export { Code };
//# sourceMappingURL=Code.mjs.map
